import React from 'react';
import { cn } from '../../lib/utils';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'navy' | 'blue' | 'teal' | 'green' | 'amber' | 'red' | 'purple' | 'gray';
}

export const Badge: React.FC<BadgeProps> = ({ 
  children, 
  variant = 'gray', 
  className,
  ...props 
}) => {
  const variants = {
    navy: 'bg-black text-white',
    blue: 'bg-[#0044FF] text-white',
    teal: 'bg-[#0044FF] text-white', // Mapping to primary brand color
    green: 'bg-[#0044FF] text-white', // Mapping to primary brand color
    amber: 'bg-[#FFD600] text-black',
    red: 'bg-[#FF0000] text-white',
    purple: 'bg-black text-white',
    gray: 'bg-white text-black border-2 border-black dark:bg-black dark:text-white dark:border-white',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-3 py-1 rounded-none border-2 border-black text-[10px] font-bold font-mono uppercase tracking-widest',
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
};
